import { createContext, useState } from 'react'

import { PublicClientApplication } from '@azure/msal-browser'

import * as graph from '@microsoft/microsoft-graph-client'

import { msalConfig, loginRequest } from '../config/azure'

export const Context = createContext()

const msalInstance = new PublicClientApplication(msalConfig);

const ContextProvider = ({ children }) => {
    const [toggle, setToggle] = useState(false)

    const [firmId, setFirmId] = useState(null)

    const [user, setUser] = useState(null)
    const [isLoaded, setIsLoaded] = useState(false)

    const [isJustOneReport, setIsJustOneReport] = useState(false)
    const [hasMobile, setHasMobile] = useState(false)

    const [report, setReport] = useState()

    const signIn = async () => {
      const response = await msalInstance.loginPopup(
        {
          scopes: loginRequest.scopes,
          prompt: "select_account"
        })

        return response.idToken
    }

    return (
      <Context.Provider value={{ 
        toggle, 
        setToggle, 
        firmId,
        setFirmId,
        user, 
        setUser,
        signIn,
        report,
        setReport,
        isLoaded,
        setIsLoaded,
        isJustOneReport, 
        setIsJustOneReport,
        hasMobile,
        setHasMobile
      }}>
        {children}
      </Context.Provider>
    )
}

export default ContextProvider